/**
 * Dashboards Metabase publics affichés dans le CRM.
 *
 * Par défaut : dashboards de prod (base fta_crm). La preprod surcharge chaque UUID par une
 * variable VUE_APP_DASHBOARD_* (voir .env.example), sinon elle afficherait les données de prod,
 * et inversement un build de prod sans variable ne pointe jamais sur la base de preprod.
 */
const DASHBOARDS = {
  // Reporting direction - Facture (id 35)
  statsComplet: process.env.VUE_APP_DASHBOARD_STATS_COMPLET || "333133a3-3b48-4c36-bd37-5f2f91fd449d",
  // Reporting commercial - Facture (id 68), « hors achats »
  stats: process.env.VUE_APP_DASHBOARD_STATS || "03ebbcf0-786b-42b9-8786-6af99b72bc02",
  // Reporting - Entreprise (id 67), fiche client
  entreprise: process.env.VUE_APP_DASHBOARD_ENTREPRISE || "3330ba05-8503-494f-a839-01e46c541c87",
  // Retards constructeur / revendeur (id 101)
  retards: process.env.VUE_APP_DASHBOARD_RETARDS || "c9770975-229e-4d1e-a353-b25a6aefbdb3",
  // Suivi visites (id 100)
  visites: process.env.VUE_APP_DASHBOARD_VISITES || "c0cdfaeb-2b02-4cf5-a56b-6ac34e9e574f",
};

export function dashboardUrl(nom) {
  return process.env.VUE_APP_REPORTING_URL + "public/dashboard/" + DASHBOARDS[nom];
}

export default DASHBOARDS;
